/**
 * Deposit Button Replacer View
 */

define(function(require, exports, module) {
    'use strict';

    var BaseReplacerView = require('common/base.replacer.view');
    var quickDepositService = require('modules/cashier/quick-deposit/quick-deposit.service.instance');
    var config = require('config');
    const urlUtil = require('util/url.util');
    const { dispatcher } = require('bundle');

    module.exports = BaseReplacerView.extend({
        tagName: 'span',

        accessRules: {
            allow: ['user']
        },

        events: {
            'tap .fn-quick-deposit': (e) => {
                e.preventDefault();
                e.stopPropagation(); // for preventing call handleLinkNavigate (header.view.js)

                const href = urlUtil.getUrlWithLanguage(config.get('quickDepositPage'));

                dispatcher.dispatch('core:navigate', href, {
                    prevPath: urlUtil.getCleanUrl(location.pathname)
                });
            }
        },

        subscribe: function() {
            this.listenTo(quickDepositService, {
                'change:isQuickDepositAvailable': this.render
            });
        },

        render: function() {
            var name = this.options.name;
            var quickDeposit = quickDepositService.isQuickDepositAvailable() && config.get('quickDepositPage');
            var deposit = config.get('depositPage');
            var depositLink = quickDeposit || deposit;

            if (depositLink) {
                const isHeaderButton = ['headerdepositbutton', 'HEADER_DEPOSIT_BUTTON'].includes(name);
                const isContentButton = ['contentdepositbutton', 'CONTENT_DEPOSIT_BUTTON'].includes(name);

                const className = [
                    'btn btn_action_deposit fn-redirect',
                    isHeaderButton && 'btn_size_small',
                    isContentButton && 'btn_deposit_balance',
                    quickDeposit && 'fn-quick-deposit'
                ].filter(Boolean).join(' ');

                this.$el.html(this.tmpl('deposit-button', {
                    className: className,
                    depositLink: depositLink,
                    depositLinkText: `playtech.mobile.system.${quickDeposit ? 'quick-deposit' : 'deposit'}`,
                }));
            }

            return this;
        }

    }, {
        nameOfReplacers: [
            'HEADER_DEPOSIT_BUTTON',
            'CONTENT_DEPOSIT_BUTTON'
        ]
    });
});
